import * as React from "react";

import "./Icon.css";

const SvgEyeCrossedIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Eye_Crossed_Icon_svg_Layer_1"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Eye_Icon_svg_cls-1{fill:none;stroke-miterlimit:10;stroke:currentColor;stroke-linecap:round;stroke-width:3px}"
        }
      </style>
    </defs>
    <path
      d="M1.5 23.88C11.9 12.85 20.08 11.47 24 11.54c4.37.08 12 1.31 22.41 12.34"
      className="Eye_Icon_svg_cls-1"
    />
    <path
      d="M46.39 23.88c-10.4 11-18.5 12-22.41 12s-12-.93-22.48-12"
      className="Eye_Icon_svg_cls-1"
    />
    <ellipse
      cx={23.95}
      cy={23.88}
      rx={6.67}
      ry={6.91}
      style={{
        fill: "none",
        strokeMiterlimit: 10,
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
      }}
    />
    <path
      id="Eye_Icon_svg_cross"
      d="m1.85 45.59 1.21 1.25L46.12 2.25 44.9 1z"
      style={{
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
        fill: "currentColor",
        strokeLinejoin: "round",
      }}
    />
  </svg>
);
export default SvgEyeCrossedIcon;
